import { render, staticRenderFns } from "./ListGarments.vue?vue&type=template&id=0f372bab"
import script from "./ListGarments.vue?vue&type=script&lang=js"
export * from "./ListGarments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports